// extracted by mini-css-extract-plugin
export default {"BuyTickets":"BuyTickets_BuyTickets__fIAap","content":"BuyTickets_content__aBoud","prizes":"BuyTickets_prizes__6Y1Ma","prizesSubtitle":"BuyTickets_prizesSubtitle__xZOlA"};